import React from 'react';
import { Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { AddCardProps } from './AddCard.types';
import styles from './AddCard.module.scss';

/**
 * Dashed "create new" tile used as the first/last cell of a card grid. Consolidates the
 * previously duplicated AddEventCard and the inline add-bundle card.
 */
export default function AddCard({
    label,
    onClick,
    icon = faPlus,
    testId,
}: AddCardProps): React.ReactElement {
    return (
        <Card className={`${styles.card} h-100`} onClick={onClick} data-testid={testId}>
            <div className={styles.content}>
                <div className={styles.iconContainer}>
                    <FontAwesomeIcon icon={icon} size="2x" />
                </div>
                <div className={styles.label}>{label}</div>
            </div>
        </Card>
    );
}
